import React, {Component} from "react";

import BrowserRouter from "react-router-dom/BrowserRouter";
import {renderRoutes} from "react-router-config";

import {applyMiddleware, createStore} from "redux";
import {Provider} from "react-redux";
import thunk from "redux-thunk";

import routes from "./routes";
import reducers from "./reducers";

const store = createStore(
    reducers, typeof window === 'undefined' ? undefined : window.INITIAL_STATE, applyMiddleware(thunk)
);

export default class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    {renderRoutes(routes)}
                </BrowserRouter>
            </Provider>
        )
    }
}


// WEBPACK FOOTER //
// ./src/js/App.js